import { Grid2, Typography } from "@mui/material";
import styles from "../styles/Admin.css";
import { useNavigate } from "react-router-dom";

function Admin() {
    const navigate = useNavigate('')
    const navAdminEspec = () => {
        navigate('/Admin/Especialidades');
    }
    const navAdminEdu = () => {
        navigate('/Admin/Educacional');
    }
    const navAdminEquipe = () => {
        navigate('/Admin/Equipe');
    }
    const navAdminBlog = () => {
        navigate('/Admin/Blog');
    }
    const navAdminSmileTrips = () => {
        navigate('/Admin/Smile-Trips');
    }
    const navAdminVideos = () => {
        navigate('/Admin/Videos-Educacionais');
    }
    return(
        <div className="container">
            <div className="body" style={{justifyItems:'center', width:'100%'}}>
                <div className="adminMenuContainer">
                    <div className="adminMenuContent">
                        <Grid2 container direction={"column"} spacing={2} justifyContent={'center'}>
                            <Grid2 item>
                                <div className="adminMenuTitle" onClick={navAdminEspec}>Especialidades</div>
                            </Grid2>
                            <Grid2 item>
                                <div className="adminMenuTitle" onClick={navAdminEdu}>Educacional</div>
                                
                            </Grid2>
                            <Grid2 item>
                                <div className="adminMenuTitle" onClick={navAdminVideos}>Vídeos Educacionais</div>
                            </Grid2>
                            <Grid2 item>
                                <div className="adminMenuTitle" onClick={navAdminEquipe}>Equipe</div>
                                
                            </Grid2>
                            <Grid2 item>
                                <div className="adminMenuTitle" onClick={navAdminBlog}>Blog</div>
                                
                            </Grid2>
                            <Grid2 item>
                                <div className="adminMenuTitle" onClick={navAdminSmileTrips}>Smile-Trips</div>
                                
                            </Grid2>
                            
                        </Grid2>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Admin;